import React from "react";
import { Paths } from "../../constants/UrlConstants";
import { connect } from "react-redux";
import {
  setMessageCentreUrl,
  resetMessageCentreUrl
} from "../../actions/messageCentre/MessageCentreActions";
import { setUnreadMessageCount } from "../../actions/inbox/InboxActions";
import { withRouter } from "react-router-dom";

export class MessageCentre extends React.Component {
  componentDidMount() {
    this.props.history.replace(Paths.Inbox);
  }

  render() {
    return (
      <></>
    );
  }
}

export const mapStateToMessageCentre = ({
  messageCentreReducer,
  policyReducer
}) => {
  return {
    messageCentreUrl: messageCentreReducer.messageCentreUrl,
    selectedPolicy: policyReducer.selectedPolicy
  };
};

export default connect(mapStateToMessageCentre, {
  setMessageCentreUrl,
  setUnreadMessageCount,
  resetMessageCentreUrl
})(withRouter(MessageCentre));
